import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EncryptServiceService {

  constructor() { }
  encryptedData(data: string): string {
    const cipherTextData = CryptoJS.AES.encrypt(JSON.stringify(data), environment.KEY);
    const ciphertext = CryptoJS.enc.Base64.stringify(CryptoJS.enc.Utf8.parse(cipherTextData));
    return ciphertext
  }
  
   decryptData(data:any): string {
    const decData = CryptoJS.enc.Base64.parse(data).toString(CryptoJS.enc.Utf8);
    const bytes = CryptoJS.AES.decrypt(decData, environment.KEY).toString(CryptoJS.enc.Utf8);
    return  JSON.parse(bytes)
   
  }
}
